var _defs, _line, _line2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGateOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke-linecap: round;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.77,
    y1: 13.77,
    x2: 12.77,
    y2: 56.42
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.23,
    y1: 13.77,
    x2: 62.23,
    y2: 56.42
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.02,56.42v3.8c0,.77-.83,1.25-1.5.87l-6.6-3.8c-.93-.54-1.5-1.53-1.5-2.6v-19.89c0-.77.29-1.5.82-2.06l7.13-7.55c.73-.77,1.65.19,1.65,1.73v29.51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m48.13,56.42v3.8c0,.77.83,1.25,1.5.87l6.6-3.8c.93-.54,1.5-1.53,1.5-2.6v-19.89c0-.77-.29-1.5-.82-2.06l-7.13-7.55c-.73-.77-1.65.19-1.65,1.73v29.51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateOpen);
export default __webpack_public_path__ + "static/media/__Gate - Open.5c1d42602dd9241163b41fc871108f37.svg";
export { ForwardRef as ReactComponent };